import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ThiTrucTuyenService } from "services/ThiTrucTuyenService";
import { ProgressSpinner } from "primereact/progressspinner";
import { Button } from "primereact/button";
import { FaArrowLeft } from "react-icons/fa";
import TypeTracNghiem from "./typequestion/TypeTracNghiem";
import TypeTracNghiemMulti from "./typequestion/TypeTracNghiemMulti";
import TypeSelect from "./typequestion/TypeSelect";
import TypeSapXepV2 from "./typequestion/TypeSapXepV2";
import TypeTuLuan from "./typequestion/TypeTuLuan";
import TypeNoi from "./typequestion/TypeNoi";
import "../../scss/ExamDetail.scss";

export default function PublicReviewExam() {
    const { attemptCode, userId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('NGUPHAP');

    const tabs = [
        { code: 'NGUPHAP', label: 'Grammar & Vocabulary' },
        { code: 'NGHE', label: 'Listening' },
        { code: 'DOC', label: 'Reading' },
        { code: 'VIET', label: 'Writing' },
        { code: 'NOI', label: 'Speaking' }
    ];

    useEffect(() => {
        loadReviewData(activeTab);
    }, [attemptCode, userId, activeTab]);

    const loadReviewData = async (typeExam) => {
        try {
            setLoading(true);
            setQuestions([]);
            // Lưu ý: Trong chế độ public, dethiId có thể không cần thiết hoặc lấy từ params nếu có
            const res = await ThiTrucTuyenService.getPublicReviewExam(attemptCode, typeExam, userId);
            if (res.data?.status === 'success') {
                setQuestions(res.data.data);
                setError(null);
            } else {
                setError(res.data?.message || "Không thể tải dữ liệu bài thi");
            }
        } catch (e) {
            console.error(e);
            setError(e.response?.data?.message || "Lỗi kết nối máy chủ");
        } finally {
            setLoading(false);
        }
    };

    const renderQuestion = (item, indexDF) => {
        return (
            <div key={item.id || item.idnhom || indexDF} style={{ marginBottom: 40 }}>
                <h3 style={{ borderBottom: '2px solid #23085a', paddingBottom: 10, color: '#23085a' }}>
                    {item.is_nhom ? `Part ${indexDF + 1}` : `Question ${indexDF + 1}`}
                </h3>
                {item.is_nhom ? (
                    <div>
                        <div dangerouslySetInnerHTML={{ __html: item.des }} style={{ marginBottom: 20 }} />
                        {item.file && item.file.includes('.mp3') && (
                            <audio controls src={item.file} style={{ width: '100%', marginBottom: 20 }} />
                        )}
                        {item.LstCauHoi && item.LstCauHoi.map((subQ, idx) => (
                            <div key={subQ.id} style={{ marginBottom: 30, padding: 15, background: '#f8f9fa', borderRadius: 8 }}>
                                <h4>Question {idx + 1}</h4>
                                {subQ.code === "TN" && <TypeTracNghiem thitructuyen={1} onChangeValue={() => {}} isNhom={true} data={subQ} userId={userId} time={0} overview={true} />}
                                {subQ.code === "TN_MULTI" && <TypeTracNghiemMulti thitructuyen={1} onChangeValue={() => {}} isNhom={true} data={subQ} userId={userId} time={0} overview={true} />}
                                {subQ.code === "SEL" && <TypeSelect thitructuyen={1} onChangeValue={() => {}} isNhom={true} data={subQ} userId={userId} time={0} overview={true} />}
                                {subQ.code === "SX" && <TypeSapXepV2 isNhom={true} data={subQ} userId={userId} time={0} overview={true} />}
                                {subQ.code === "VIET" && <TypeTuLuan isNhom={true} data={subQ} userId={userId} time={0} overview={true} indexDF={0} index={idx} selected={subQ.selected?.vanbantraloi || subQ.selected} />}
                                {subQ.code === "NOI" && <TypeNoi data={subQ} userId={userId} overview={true} selected={subQ.selected?.vanbantraloi || subQ.selected} />}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div style={{ padding: 15, background: '#f8f9fa', borderRadius: 8 }}>
                        {item.code === "TN" && <TypeTracNghiem thitructuyen={1} isNhom={false} onChangeValue={() => {}} data={item} userId={userId} time={0} overview={true} />}
                        {item.code === "TN_MULTI" && <TypeTracNghiemMulti thitructuyen={1} isNhom={false} onChangeValue={() => {}} data={item} userId={userId} time={0} overview={true} />}
                        {item.code === "SEL" && <TypeSelect thitructuyen={1} isNhom={false} onChangeValue={() => {}} data={item} userId={userId} time={0} overview={true} />}
                        {item.code === "SX" && <TypeSapXepV2 isNhom={false} data={item} userId={userId} time={0} overview={true} />}
                        {item.code === "VIET" && <TypeTuLuan isNhom={false} data={item} userId={userId} time={0} overview={true} indexDF={0} index={0} selected={item.selected?.vanbantraloi || item.selected} />}
                        {item.code === "NOI" && <TypeNoi data={item} userId={userId} overview={true} selected={item.selected?.vanbantraloi || item.selected} />}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div style={{ padding: '20px 40px', background: '#f4f6f8', minHeight: '100vh', fontFamily: "'Inter', sans-serif" }}>
            <div style={{ maxWidth: 1000, margin: '0 auto', background: '#fff', padding: '30px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 style={{ margin: 0, color: '#111827', fontWeight: 700 }}>Public Review Exam</h2>
                    <Button 
                        label="Quay lại Kết Quả" 
                        icon={<FaArrowLeft style={{marginRight: 8}}/>} 
                        onClick={() => navigate(-1)}
                        style={{ background: '#f3f4f6', color: '#374151', border: 'none', padding: '10px 20px', borderRadius: 10, fontWeight: 600 }}
                    />
                </div>

                <div style={{ display: 'flex', gap: 10, marginBottom: 30, borderBottom: '2px solid #e5e7eb', paddingBottom: 15, overflowX: 'auto' }}>
                    {tabs.map(tab => (
                        <button
                            key={tab.code}
                            onClick={() => setActiveTab(tab.code)}
                            style={{
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '8px',
                                background: activeTab === tab.code ? '#23085a' : 'transparent',
                                color: activeTab === tab.code ? '#fff' : '#6b7280',
                                fontWeight: 600,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                {error && (
                    <div style={{ padding: 20, background: '#fee2e2', color: '#991b1b', borderRadius: 8, textAlign: 'center', marginBottom: 20 }}>
                        {error}
                    </div>
                )}

                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', margin: '100px 0' }}>
                        <ProgressSpinner />
                    </div>
                ) : (
                    <div>
                        {questions.length === 0 && !error ? (
                            <div style={{ textAlign: 'center', padding: '50px 0', color: '#6b7280' }}>
                                <h4>Không có dữ liệu cho phần thi này.</h4>
                            </div>
                        ) : (
                            questions.map((q, idx) => renderQuestion(q, idx))
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
